import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-trusted",
  templateUrl: "./trusted.component.html",
  styleUrls: ["./trusted.component.scss"],
})
export class TrustedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
  }

  @ViewChild("testDiv", { static: false })
  private testDiv: ElementRef<HTMLDivElement>;
  isTestDivScrolledIntoView: boolean;
  doIt = true;
  @HostListener("window:scroll", ["$event"])
  isScrolledIntoView() {
    if (this.testDiv) {
      const rect = this.testDiv.nativeElement.getBoundingClientRect();
      const topShown = rect.top >= 0;
      const bottomShown = rect.bottom <= window.innerHeight + 500;
      let doc=document.getElementById('trusted');
      if (topShown && bottomShown && this.doIt) {
        this.isTestDivScrolledIntoView = true;
        doc.classList.add('trustedAnimation')
        this.doIt = false;
      }
    }
  }
}
